import { ajax } from '../utils';

var getAirlineInfoByFlightNumber = function getAirlineInfoByFlightNumber(arelineDB, flightnumber) {
  var three = flightnumber.substr(2, 1);
  var result;

  if (three >= 'A' && three <= 'Z') {
    result = arelineDB.find(function (x) {
      return x.ICAO === flightnumber.substring(0, 3);
    });
  } else {
    result = arelineDB.find(function (x) {
      return x.IATA === flightnumber.substring(0, 2);
    });
  }

  return result;
};

var asyncGetAirlineInfoByFlightNumber = function asyncGetAirlineInfoByFlightNumber(flightnumber, url) {
  if (typeof flightnumber !== 'string') {
    console.error('[callsign.js]: flightnumber must be string');
    return;
  }

  flightnumber = flightnumber.toUpperCase();

  if (url === undefined) {
    url = 'https://unpkg.com/callsign/dist/data/airlineDB.json';
  }

  return new Promise(function (resolve, reject) {
    ajax('GET', url).then(function (res) {
      var getDetail = getAirlineInfoByFlightNumber(JSON.parse(res), flightnumber);
      resolve(getDetail);
    })["catch"](function (e) {
      reject('[callsign.js]: Network Error');
    });
  });
};

export default asyncGetAirlineInfoByFlightNumber;